"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var WishlistProduct = /** @class */ (function (_super) {
    __extends(WishlistProduct, _super);
    function WishlistProduct() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleAddToCart = function (variant) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, next_components_1.ShopifyNext.Cart.addItem(parseInt(variant, 10), 1)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleMouseOver = function () {
            _this.setState({
                hoverState: true
            });
        };
        _this.handleMouseOut = function () {
            _this.setState({
                hoverState: false
            });
        };
        return _this;
    }
    WishlistProduct.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            product: this.props.product,
            hasVariants: this.props.product.product.variants.length > 1,
            variant: this.props.product.product.variants.find(function (variant) { return variant.id == _this.props.product.epi; }),
            hoverState: false
        });
    };
    WishlistProduct.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.product !== prevProps.product) {
            this.setState({
                product: this.props.product,
                hasVariants: this.props.product.product.variants.length > 1,
                variant: this.props.product.product.variants.find(function (variant) { return variant.id == _this.props.product.epi; })
            });
        }
    };
    WishlistProduct.prototype.render = function () {
        var _this = this;
        var _a = this.state, product = _a.product, variant = _a.variant, hasVariants = _a.hasVariants, hoverState = _a.hoverState;
        var productObject = product.product;
        variant.price = variant.price * 100;
        variant.compare_at_price = variant.compare_at_price * 100;
        return (React.createElement("div", { className: "flex flex-col flex-1 bg-arctic relative transition-fast " + (hoverState ? "shadow-active md:min-h-42" : "shadow-block md:min-h-42"), key: this.props.key, onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut },
            React.createElement(Snippets.BlockImage, { image: productObject.image.src, hoverImage: productObject.images[1] ? productObject.images[1].src : "", ratio: "1:1", className: "", hover: hoverState, href: product.du, title: productObject.title }),
            React.createElement("div", { className: "px-1-6 pt-1-2 pb-1-9 md:pb-1-6 block no-underline group flex flex-col flex-1" },
                React.createElement("div", { className: "flex flex-col items-between flex-1" },
                    React.createElement("a", { className: "flex flex-col text-midnight mb-0-2 md:mb-0-8 flex-1 md:pr-2", title: productObject.title, href: product.du },
                        React.createElement("h4", { className: "font-semibold text-sm md:text-base tracking-normal leading-1.29 " }, productObject.title)),
                    React.createElement(Snippets.ProductPrice, { variant: variant, layout: "collection", showDiscount: false, showCurrency: false, moneyFormat: this.context.state.shop.money_format, moneyFormatCurrency: this.context.state.shop.money_with_currency_format, inline: true })),
                React.createElement("div", { className: "relative p-1-6 text-xs" }, !hasVariants ? (React.createElement("button", { className: "flex justify-center items-center text-xs h-4 w-full mt-0-8 mb-1-6 bg-navy text-arctic font-bold rounded", onClick: function () { return _this.handleAddToCart(variant.id); } }, "Add to Cart")) : (React.createElement("a", { className: "flex justify-center items-center text-xs h-4 w-full mt-0-8 mb-1-6 bg-navy text-arctic font-bold rounded", href: product.du }, "Select Size"))),
                this.props.children)));
    };
    return WishlistProduct;
}(React.PureComponent));
exports.WishlistProduct = WishlistProduct;
WishlistProduct.contextType = next_components_1.ShopifyNext.Context;
